<script setup lang="ts">
import { RrModal, type ModalProps } from '@xjlv2/ui'

const props = withDefaults(defineProps<ModalProps>(), {
  open: false, width: 600, centered: true,
  closable: undefined, mask: undefined, maskClosable: undefined, keyboard: undefined,
  confirmLoading: undefined, showFooter: undefined, showCancel: undefined, showOk: undefined,
  destroyOnClose: undefined, forceRender: undefined, footer: undefined, getContainer: undefined
})
const emit = defineEmits<{ 'update:open': [open: boolean]; cancel: [event?: Event]; ok: [event: MouseEvent]; afterClose: [] }>()
</script>

<template>
  <RrModal v-bind="props" @update:open="emit('update:open', $event)" @cancel="emit('cancel', $event)" @ok="emit('ok', $event)" @after-close="emit('afterClose')">
    <template v-for="(_, name) in $slots" #[name]="slotProps"><slot :name="name" v-bind="slotProps ?? {}" /></template>
  </RrModal>
</template>
